module.exports = __webpack_public_path__ + "static/media/dog-footprint.5b605f84.svg";